import { ETypographyColor, ETypographySize, ETypographyTag, Typography } from "@/3514/components"
import { buildCssClassName } from "@/3514/utils"

import "./styles.scss"

type Props = {
    isToggled: boolean
    name?: string
    label?: string
    onToggle: () => void
    isRedesigned?: boolean
}

const Switcher = ({ isToggled, name, label, onToggle, isRedesigned = false }: Props) => {
    return (
        <div className="toggle-box flex items-center gap-x-[8px]">
            {label?.length > 0 ? (
                <Typography
                    text={label}
                    color={isRedesigned ? ETypographyColor.Black : ETypographyColor.Error}
                    tag={ETypographyTag.Span}
                    size={ETypographySize.Tiny}
                />
            ) : null}

            <label
                className={buildCssClassName("toggle-switch", {
                    "w-[33px] h-[20px] redesigned": isRedesigned,
                    "w-[50px] h-[30px]": !isRedesigned
                })}
            >
                <input type="checkbox" name={name} checked={isToggled} onChange={onToggle} />
                <span className={buildCssClassName("switch", { redesigned: isRedesigned })} />
            </label>
        </div>
    )
}

export default Switcher
